<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="'anchor'">
    <a *ngIf="href" class="Body---Link" href="{{ href }}" [target]="target">
      <i class="fal fa-fw fa-chevron-down prefix-icon"></i
      ><span><ng-container *ngTemplateOutlet="contentTpl"></ng-container></span
    ></a>
    <a *ngIf="!href" class="Body---Link" (click)="onClick()">
      <i class="fal fa-fw fa-chevron-down prefix-icon"></i>
      <span><ng-container *ngTemplateOutlet="contentTpl"></ng-container></span>
    </a>
    <a *ngIf="routerLink" class="Body---Link" routerLink="{{ routerLink }}" fragment="{{ fragment }}"
      ><i class="fal fa-fw fa-chevron-down prefix-icon"></i
      ><span><ng-container *ngTemplateOutlet="contentTpl"></ng-container></span
    ></a>
  </ng-container>

  <ng-container *ngSwitchCase="'back'">
    <a *ngIf="href" class="Body-Small---Link" href="{{ href }}"
      ><i class="fal fa-fw fa-chevron-left prefix-icon back-link-icon"></i
      ><span><ng-container *ngTemplateOutlet="contentTpl"></ng-container></span
    ></a>

    <a *ngIf="routerLink" class="Body-Small---Link" [routerLink]="routerLink"
      ><i class="fal fa-fw fa-chevron-left prefix-icon back-link-icon"></i
      ><span><ng-container *ngTemplateOutlet="contentTpl"></ng-container></span
    ></a>
  </ng-container>

  <a class="Body---Link" href="{{ href }}" *ngSwitchCase="'showmore'" (click)="toggle()"
    ><span><ng-container *ngTemplateOutlet="contentTpl"></ng-container></span
    ><i class="fal fa-fw suffix-icon" [ngClass]="{ 'fa-chevron-up': isExpanded, 'fa-chevron-down': !isExpanded }"></i
  ></a>
  <a class="Body---Link" href="{{ href }}" *ngSwitchCase="'showmoreicon'" (click)="toggle()"
    ><i class="fal fa-fw fa-info-circle prefix-icon"></i
    ><span><ng-container *ngTemplateOutlet="contentTpl"></ng-container></span
    ><i class="fal fa-fw suffix-icon" [ngClass]="{ 'fa-chevron-up': isExpanded, 'fa-chevron-down': !isExpanded }"></i
  ></a>
  <a class="standalone-link" href="javascript: void(0);" *ngSwitchCase="'button'" (click)="onClick()">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </a>

  <ng-container *ngSwitchDefault>
    <a *ngIf="href" class="standalone-link" href="{{ href }}" [target]="target"
      ><ng-container *ngTemplateOutlet="contentTpl"></ng-container
    ></a>
    <a *ngIf="routerLink" class="standalone-link" [routerLink]="routerLink"
      ><ng-container *ngTemplateOutlet="contentTpl"></ng-container
    ></a>
  </ng-container>
</ng-container>
<ng-template #contentTpl><ng-content></ng-content></ng-template>
